import { useAtomValue } from 'jotai';

import { useTranslate } from '@growtherapy/i18n';

import {
  LocalMediaStatus,
  hasBackgroundProcessorFailureAtom,
  localVideoContextAtom,
  useStoredAudioVideoSettings,
  useSwitchBackground,
} from '../../video-sdk';
import { permissionDeniedAtom } from '../../video-sdk/twilio';
import { BackgroundSettingsTab } from './BackgroundSettingsTab';

export function BackgroundSettingsTabWrapper() {
  const t = useTranslate();
  const { videoIsBlocked } = useAtomValue(permissionDeniedAtom);
  const hasBackgroundProcessorFailure = useAtomValue(hasBackgroundProcessorFailureAtom);
  const { delegator: localVideoDelegator, status: localVideoStatus } = useAtomValue(localVideoContextAtom);
  const isVideoEnabled = localVideoDelegator && localVideoStatus === LocalMediaStatus.READY;
  const { storedAudioVideoSettings } = useStoredAudioVideoSettings();
  const helpText = videoIsBlocked
    ? t('telehealth-core:settings.cameraIsNotEnabledAllowAccessFromSiteSettings')
    : t('telehealth-core:settings.cameraIsTurnedOffSelectingBackgroundWillTurnOn');

  const switchBackground = useSwitchBackground();

  return (
    <BackgroundSettingsTab
      setBackgroundSettings={switchBackground}
      isMirrored={storedAudioVideoSettings?.videoIsMirrored ?? false}
      backgroundsSelectionIsDisabled={videoIsBlocked}
      selectedBackground={storedAudioVideoSettings?.backgroundType}
      selectedBackgroundIndex={storedAudioVideoSettings?.backgroundIndex}
      {...(!isVideoEnabled && {
        helpText,
      })}
      hasBackgroundProcessorFailure={hasBackgroundProcessorFailure}
    />
  );
}
